import { render, staticRenderFns } from "./application-section.vue?vue&type=template&id=38766412&scoped=true"
import script from "./application-section.vue?vue&type=script&lang=js"
export * from "./application-section.vue?vue&type=script&lang=js"
import style0 from "./application-section.vue?vue&type=style&index=0&id=38766412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38766412",
  null
  
)

export default component.exports